import { render, staticRenderFns } from "./RecPointStatsDialog.vue?vue&type=template&id=7675634a&scoped=true"
import script from "./RecPointStatsDialog.vue?vue&type=script&lang=js"
export * from "./RecPointStatsDialog.vue?vue&type=script&lang=js"
import style0 from "./RecPointStatsDialog.vue?vue&type=style&index=0&id=7675634a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7675634a",
  null
  
)

export default component.exports